class MitFeaturesService {
  constructor() {
    this.names = {
      ADMIN_RESET_PASSWORD: 'admin-reset-password',
      ADMIN_EQUIPMENT: 'admin-equipment',
      EQUIPMENT: 'equipment',
      KEYS: 'keys'
    }
  }
}
export default new MitFeaturesService();
